// extracted by mini-css-extract-plugin
export var btn = "F_mB q_rL q_rm d_bz d_bP d_bD d_dw";
export var full = "F_vx d_w d_H";